export default "__VITE_ASSET__BvB2j5yX__"